import React from 'react';
import { ServerStatus } from '../util/serverStatus';
import './commonStyle.css';

/**
 * ServerStatusModal - Gentle confirmation for connecting to OFFLINE or FIREWALL servers
 *
 * Props:
 * - show: boolean
 * - serverName: string
 * - serverStatus: ServerStatus
 * - lastSeen: string
 * - isConnecting: boolean - shows connecting state
 * - connectionError: string - shows error message if connection failed
 * - onCancel: function
 * - onConfirm: function
 */
const ServerStatusModal = ({
  show,
  serverName,
  serverStatus,
  lastSeen,
  isConnecting,
  connectionError,
  onCancel,
  onConfirm
}) => {
  if (!show) return null;

  const isOffline = serverStatus === ServerStatus.OFFLINE;
  const statusModifier = isOffline ? 'offline' : 'warning';

  // Connecting state
  if (isConnecting) {
    return (
      <div className="common-modal-overlay common-modal-overlay--light">
        <div className="common-server-modal">
          <div className="common-server-modal__spinner" />
          <p className="common-server-modal__name">{serverName}</p>
          <p className="common-server-modal__connecting-text">Connecting...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (connectionError) {
    return (
      <div className="common-modal-overlay common-modal-overlay--light">
        <div className="common-server-modal">
          <div className="common-server-modal__dot common-server-modal__dot--offline" />
          <p className="common-server-modal__name">{serverName}</p>
          <p className="common-server-modal__status common-server-modal__status--offline">
            {connectionError}
          </p>
          <div className="common-server-modal__buttons">
            <button
              onClick={onCancel}
              className="common-server-modal__button common-server-modal__button--cancel"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Default confirmation state
  return (
    <div className="common-modal-overlay common-modal-overlay--light">
      <div className="common-server-modal">
        <div className={`common-server-modal__dot common-server-modal__dot--${statusModifier}`} />
        <p className="common-server-modal__name">{serverName}</p>
        <p className={`common-server-modal__status common-server-modal__status--${statusModifier}`}>
          {isOffline ? 'Server appears offline' : 'May be behind a firewall'}
        </p>
        <p className="common-server-modal__last-seen">Last seen: {lastSeen}</p>
        <p className="common-server-modal__question">Try connecting anyway?</p>
        <div className="common-server-modal__buttons">
          <button
            onClick={onCancel}
            className="common-server-modal__button common-server-modal__button--cancel"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`common-server-modal__button common-server-modal__button--connect ${isOffline ? 'offline' : ''}`}
          >
            Connect
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerStatusModal;
